import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class WeekInfoDTO  {
    _originalTypeClassName = "ekylikeio.BO.WeekInfoDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
WeekInfoDTO.translate = translateService;
}
this.StartDate = null;
this.EndDate = null;
this.WeekInfoDTOKey = null;
this._key = this.WeekInfoDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
StartDate:any;
EndDate:any;
private _WeekInfoDTOKey:any;
get WeekInfoDTOKey(): any {
    return this._WeekInfoDTOKey;
  }
set WeekInfoDTOKey(value: any) {
    this._WeekInfoDTOKey = value;
    this._key = value;
  }

static GetCurrentWeek(): any{return Domain.WeekInfoDTO.GetWeek(moment().toDate());
}
static GetWeek(refDate: any): any{let week = new Domain.WeekInfoDTO();
week.StartDate = refDate;
if (CLMS.Framework.Number.Equal(() => moment(week.StartDate).day(), () => 6)) {week.StartDate = (moment(week?.StartDate).add(2, "d")).toDate();}
if (CLMS.Framework.Number.Equal(() => moment(week.StartDate).day(), () => 0)) {week.StartDate = (moment(week?.StartDate).add(1, "d")).toDate();}
while (CLMS.Framework.Number.NotEqual(() => moment(week.StartDate).day(), () => 1)) {week.StartDate = (moment(week?.StartDate).add(-1, "d")).toDate();}
week.EndDate = (moment(week?.StartDate).add(4, "d")).toDate();
return week;
}
static Next($this: any): any{return Domain.WeekInfoDTO.GetWeek((moment($this?.EndDate).add(4, "d")).toDate());
}
static Prev($this: any): any{return Domain.WeekInfoDTO.GetWeek((moment($this?.StartDate).add(-4, "d")).toDate());
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.WeekInfoDTOKey == null || $this.WeekInfoDTOKey == 0;
            }


}